import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import BreadCrumbs from "@/components/Gallery/BreadCrumbs";
import { usePathname } from "next/navigation";
import { getBlogPageUrl, getBlogUrl } from "@/lib/blog";
import { getHeroBreadcrumbSegments } from "./getHeroBreadcrumbSegments";

interface HeroNarrowData {
  title: string;
  subtitle?: string;
  theme: "dark" | "light";
}

interface HeroNarrowProps {
  data: HeroNarrowData;
  pageData: any;
}

export default function HeroNarrow({ data, pageData }: HeroNarrowProps) {
  const pathnameRaw = usePathname();
  const [pathname, setPathname] = useState<string | null>(null);
  useEffect(() => {
    setPathname(pathnameRaw);
  }, [pathnameRaw]);
  const { title, subtitle, theme } = data;
  let sectionClass = "bg-[#2C3540]";
  let textClass = "text-[#F3E6D8]";
  if (theme === "light") {
    sectionClass = "bg-accent-color-three-light";
    textClass = "text-[#FFFFFF]";
  }

  return (
    <>
      <section
        className={cn(
          "w-full py-12 flex items-center justify-center min-h-[15vw]",
          sectionClass
        )}
      >
        <div className="max-w-[85vw] w-full mx-auto">
          <h1
            className={`font-serif text-h2-mobile md:text-h2-tablet desktop:text-h2-desktop ${textClass} text-center`}
          >
            {title}
          </h1>
          {subtitle && (
            <h2 className="font-sans text-h5-mobile md:text-h5-tablet desktop:text-h5-desktop text-[#FFF] text-center mt-4 uppercase tracking-[0.15em]">
              {subtitle}
            </h2>
          )}
        </div>
      </section>
      {pathname && !pathname?.includes(getBlogUrl()) && (
        <BreadCrumbs
          hideOnHomepage
          className="bg-accent-color-three-light text-[#fff] py-6 px-6 md:py-6 md:px-12 lg:py-8 lg:px-32 m-0 text-span-medium"
          segments={getHeroBreadcrumbSegments(pathname, pageData.title)}
        />
      )}
    </>
  );
}
